export default __webpack_public_path__ + "static/media/Icon41.df39028f.svg";